/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import {
    EditButton,
    List,
    TextField,
    BooleanField,
    ReferenceField,
} from 'react-admin'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import ListTitle from '../../../../components/ListTitle'
import Datagrid from '../../../../components/Datagrid/Datagrid'
import Filter from '../../../../components/Filter/FilterComponents'

const styles = {
    myHeader: {
        '&&:before': {
            content: '" ⇅ "',
        },
    },
    header: {
        display: 'none',
    },
}
const useStyles = makeStyles(styles)

export default function FormList(props) {
    const classes = useStyles(props)
    const { quickSearch } = props
    return (
        <List
            sort={{ field: 'code', order: 'ASC' }}
            filters={<Filter {...props} />}
            {...props}
        >
            <>
                <ListTitle label="Forms" />
                <Datagrid {...props}>
                    <TextField
                        label="Code"
                        headerClassName={classes.myHeader}
                        source="code"
                    />
                    <TextField
                        label="Description"
                        headerClassName={classes.myHeader}
                        source="description"
                    />

                    <ReferenceField source="module_id" reference="SS_ModuleTAB">
                        <TextField label="Module" source="description" />
                    </ReferenceField>

                    <ReferenceField
                        source="formtype_id"
                        reference="SS_FormTypeTAB"
                    >
                        <TextField
                            label="Form Type"
                            headerClassName={classes.myHeader}
                            source="description"
                        />
                    </ReferenceField>

                    <BooleanField label="Display" source="is_display" />
                    {quickSearch ? (
                        <EditButton
                            headerClassName={classes.header}
                            basePath="/SS_FormTAB"
                        />
                    ) : (
                        <EditButton basePath="/SS_FormTAB" />
                    )}
                </Datagrid>
            </>
        </List>
    )
}

FormList.defaultProps = {
    quickSearch: false,
}
FormList.propTypes = {
    quickSearch: PropTypes.bool,
}
